import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';


const ContentManagement = () => {
  const [contentType, setContentType] = useState('blog');
  const [searchQuery, setSearchQuery] = useState('');

  const contentTypes = [
    { id: 'blog', label: 'Blog Posts', icon: 'FileText' },
    { id: 'projects', label: 'Projects', icon: 'Briefcase' },
    { id: 'services', label: 'Services', icon: 'Layers' },
    { id: 'testimonials', label: 'Testimonials', icon: 'MessageCircle' }
  ];

  const mockBlogPosts = [
    {
      id: 1,
      title: 'Getting Started with React',
      status: 'published',
      date: '2024-01-10',
      views: 1234
    },
    {
      id: 2,
      title: 'Advanced TypeScript Patterns',
      status: 'draft',
      date: '2024-01-12',
      views: 0
    },
    {
      id: 3,
      title: 'Building Scalable Applications',
      status: 'published',
      date: '2024-01-08',
      views: 2341
    }
  ];

  const getStatusColor = (status) => {
    return status === 'published' ? 'success' : 'warning';
  };

  return (
    <div className="space-y-6">
      {/* Content Type Tabs */}
      <div className="flex flex-wrap gap-2">
        {contentTypes?.map((type) => (
          <Button
            key={type?.id}
            variant={contentType === type?.id ? 'default' : 'outline'}
            size="sm"
            iconName={type?.icon}
            onClick={() => setContentType(type?.id)}
            className="touch-manipulation"
          >
            <span className="hidden sm:inline">{type?.label}</span>
            <span className="sm:hidden">{type?.label?.split(' ')?.[0]}</span>
          </Button>
        ))}
      </div>

      {/* Search and Actions */}
      <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center justify-between">
        <div className="w-full sm:w-96">
          <Input
            type="text"
            placeholder="Search content..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
          />
        </div>
        <Button iconName="Plus" size="sm" className="touch-manipulation w-full sm:w-auto">
          <span className="hidden sm:inline">Add New {contentType === 'blog' ? 'Post' : contentType === 'projects' ? 'Project' : contentType === 'services' ? 'Service' : 'Testimonial'}</span>
          <span className="sm:hidden">Add New</span>
        </Button>
      </div>

      {/* Content List */}
      <div className="rounded-xl border border-border/50 backdrop-blur-xl overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.6), rgba(15, 23, 42, 0.8))'
        }}
      >
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px]">
            <thead className="border-b border-border/50">
              <tr>
                <th className="text-left p-3 sm:p-4 text-xs sm:text-sm font-semibold text-muted-foreground">Title</th>
                <th className="text-left p-3 sm:p-4 text-xs sm:text-sm font-semibold text-muted-foreground">Status</th>
                <th className="text-left p-3 sm:p-4 text-xs sm:text-sm font-semibold text-muted-foreground hidden sm:table-cell">Date</th>
                <th className="text-left p-3 sm:p-4 text-xs sm:text-sm font-semibold text-muted-foreground hidden md:table-cell">Views</th>
                <th className="text-right p-3 sm:p-4 text-xs sm:text-sm font-semibold text-muted-foreground">Actions</th>
              </tr>
            </thead>
            <tbody>
              {mockBlogPosts?.map((post) => (
                <tr key={post?.id} className="border-b border-border/30 hover:bg-muted/20 transition-colors">
                  <td className="p-3 sm:p-4">
                    <p className="text-foreground font-medium text-sm sm:text-base">{post?.title}</p>
                  </td>
                  <td className="p-3 sm:p-4">
                    <span
                      className="inline-flex items-center gap-1 px-2 sm:px-3 py-1 rounded-full text-xs font-medium"
                      style={{
                        background: `var(--color-${getStatusColor(post?.status)})`,
                        color: 'white'
                      }}
                    >
                      {post?.status}
                    </span>
                  </td>
                  <td className="p-3 sm:p-4 text-muted-foreground text-sm hidden sm:table-cell">{post?.date}</td>
                  <td className="p-3 sm:p-4 text-muted-foreground text-sm hidden md:table-cell">{post?.views}</td>
                  <td className="p-3 sm:p-4">
                    <div className="flex items-center justify-end gap-1 sm:gap-2">
                      <Button variant="ghost" size="icon" iconName="Edit" className="touch-manipulation" />
                      <Button variant="ghost" size="icon" iconName="Trash2" className="touch-manipulation" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ContentManagement;